export default "__VITE_ASSET__BeLm$obN__"